import styled from "styled-components";

export const FeatureSection = styled.section`
  padding: 80px 20px;
  background-color: var(--darkBG);
  color: var(--lightText);
  position: relative;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 56px 16px;
  }
`;

export const Container = styled.div`
  max-width: var(--maxWidth);
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
  display: grid;
  gap: 28px;
  justify-items: center;
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

export const HeaderTitle = styled.h2`
  font-size: clamp(2.5rem, 5vw, 3.8rem);
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 30%, var(--accentGold) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 3px;
  line-height: 1.1;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
    letter-spacing: 1px;
  }
`;

export const HeaderSubtitle = styled.h3`
  font-size: 1.15rem;
  color: #cfc9be;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 10px 28px;
  border-radius: 999px;
  background: rgba(212, 175, 55, 0.08);
  box-shadow: inset 0 0 0 1px rgba(212, 175, 55, 0.2);
  display: inline-block;
  margin: 0;
  line-height: 1.4;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 8px 20px;
    letter-spacing: 1px;
  }
`;

export const HeaderDescription = styled.p`
  font-size: var(--fontSmall);
  color: #a1a1aa;
  max-width: 680px;
  margin: 0;
  margin-top: 10px;
  line-height: 1.8;
  padding: 0 10px;
`;

export const FeatureImageContainer = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto 50px auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.05);
  background: #111;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    object-position: center;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 36px;
  }
`;

export const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  @media (max-width: 480px) {
    padding: 22px 18px;
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
      border-color: var(--accentGold);
      box-shadow: 0 10px 30px rgba(212, 175, 55, 0.1);
    }
  }

  h3 {
    font-size: var(--fontMed);
    color: #fff;
    margin-bottom: 18px;
    padding-left: 18px;
    position: relative;
    line-height: 1.2;
  }

  h3::before {
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 6px;
    height: 24px;
    border-radius: 4px;
    background: var(--accentGold);
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;

  li {
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    font-size: 0.95rem;
    color: #d1d5db;

    &::before {
      content: "▹";
      color: var(--accentGold);
      margin-right: 10px;
      font-size: 1.2rem;
    }
  }
`;

export const HighlightBox = styled.div`
  background: linear-gradient(135deg, var(--accentGold) 0%, #b8860b 100%);
  border-radius: 15px;
  padding: 30px;
  color: #111;
  text-align: center;
  font-weight: 600;

  h3 {
    color: #111;
    font-size: 1.4rem;
    margin-bottom: 15px;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    position: relative;
  }

  h3::after {
    content: "";
    display: block;
    width: 64px;
    height: 5px;
    margin: 12px auto 0;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.16);
  }

  p {
    font-size: 0.95rem;
    margin-bottom: 10px;
  }

  .offer {
    display: inline-block;
    background: #111;
    color: var(--accentGold);
    padding: 8px 15px;
    border-radius: 20px;
    margin-top: 15px;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

export const BrandMarquee = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  align-items: center;

  .brand-logo-card {
    width: 240px;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.35);
    background: #111;
    padding: 20px;
    transition: all 0.3s ease;

    img {
      height: 48px;
      width: auto;
      object-fit: contain;
      max-width: 100%;
    }

    img.jk-logo,
    img.bridgestone-logo {
      filter: invert(1) hue-rotate(180deg);
    }

    span {
      font-size: 1.1rem;
      font-weight: 700;
      color: #faf9f6;
      letter-spacing: 1.5px;
      text-transform: uppercase;
    }

    &:hover {
      transform: translateY(-5px);
      border-color: var(--accentGold);
      box-shadow: 0 12px 35px rgba(212, 175, 55, 0.25);
    }
  }

  @media (max-width: 768px) {
    gap: 24px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    padding-top: 28px;

    .brand-logo-card {
      width: 180px;
      height: 120px;
      gap: 12px;
      padding: 16px;

      img {
        height: 36px;
      }

      span {
        font-size: 0.95rem;
        letter-spacing: 1px;
      }
    }
  }
`;

export const ContactInfo = styled.div`
  text-align: center;
  margin-top: 50px;
  color: #a1a1aa;
  font-size: 0.9rem;

  p {
    margin-bottom: 8px;
  }

  strong {
    color: var(--accentGold);
  }
`;

export const CallButton = styled.a`
  display: inline-block;
  margin-top: 20px;
  padding: 12px 30px;
  background-color: var(--accentGold);
  color: #111;
  text-decoration: none;
  font-weight: bold;
  border-radius: 25px;
  text-transform: uppercase;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 5px 20px rgba(212, 175, 55, 0.4);
  }
`;

export const CarouselNote = styled.p`
  text-align: center;
  font-size: 0.88rem;
  color: #a1a1aa;
  margin-top: -30px;
  margin-bottom: 40px;
  font-style: italic;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    margin-top: -20px;
    margin-bottom: 30px;
    font-size: 0.8rem;
  }
`;

export const GuidePromoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  max-width: 960px;
  margin: 50px auto 30px auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin: 40px 16px 20px;
  }
`;

export const GuidePromoCard = styled.div`
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.04) 100%);
  border: 1px solid rgba(212, 175, 55, 0.15);
  border-radius: 20px;
  padding: 35px 25px;
  text-align: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: var(--accentGold);
    box-shadow: 0 15px 35px rgba(212, 175, 55, 0.15);
    transform: translateY(-5px);
  }

  h3 {
    font-size: 1.4rem;
    color: #ffffff;
    margin-top: 0;
    margin-bottom: 12px;
    font-weight: 700;
  }

  p {
    font-size: 0.95rem;
    color: #a1a1aa;
    line-height: 1.6;
    margin-bottom: 24px;
    flex: 1;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    
    h3 {
      font-size: 1.3rem;
    }
    
    p {
      font-size: 0.9rem;
    }
  }
`;

export const PromoButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 30px;
  background: var(--accentGold);
  color: #111;
  font-weight: 700;
  font-size: 0.95rem;
  border-radius: 30px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.15);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(212, 175, 55, 0.3);
    color: #111;
  }
`;
